import { isInitiativeProject, isRequirementsProject } from './initiatives';
import { isServiceRequestProject } from './service-requests';

/**
 * Service Requests, Initiatives and Business requirements each keep their records in a hidden
 * workspace. None is a stream: they are left out of stream lists, pickers and the switcher.
 */
export function isWorkspaceProject(project: { identifier?: string | null } | null | undefined): boolean {
  return isServiceRequestProject(project) || isInitiativeProject(project) || isRequirementsProject(project);
}
